.sub-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--color-neutral-500);
}
.sub-title-label {
  font-size: var(--font-size-sm);
  color: var(--color-neutral-400);
  font-weight: var(--font-weight-regular);
}
.sub-title-date {
  font-size: var(--font-size-sm);
  color: var(--color-neutral-600);
  font-weight: var(--font-weight-regular);
  word-break: break-word;
}

.real-row {
  align-items: center;
}

.edit-icon-btn {
  cursor: pointer;
  color: var(--color-neutral-400);
}
.edit-icon-btn:hover {
  color: var(--color-neutral-600);
}

.edit-time-container {
  padding: 4px 0;
}

.edit-time-label {
  font-weight: 700;
}

.justification-link {
  all: unset;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: fit-content;
  color: var(--feedback-danger-400, #AE1E1E);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  cursor: pointer;
}
.justification-link svg,
.justification-link path {
  color: var(--feedback-danger-400, #AE1E1E);
  fill: var(--feedback-danger-400, #AE1E1E);
}

.justification-link-readonly {
  color: var(--color-neutral-900, #000000);
}
.justification-link-readonly svg,
.justification-link-readonly path {
  color: var(--color-neutral-900, #000000);
  fill: var(--color-neutral-900, #000000);
}

.justification-form {
  --justification-counter-space: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 15px 0;
}
.justification-form :global(.clb-input__footer__char-count) {
  font-size: 12px;
  line-height: 1rem;
}
.justification-form > :global(.clb-select),
.justification-form > :global(.clb-multi-select),
.justification-form > .justification-radio-group {
  margin-bottom: var(--justification-counter-space);
}

.justification-select-with-value :global(.clb-select__input::placeholder) {
  color: var(--color-neutral-700, #303030);
  opacity: 1;
}

.justification-radio-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.justification-field-label {
  font-size: var(--font-size-sm);
  color: var(--color-neutral-600);
  font-weight: var(--font-weight-regular);
}

.justification-footer {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.divider {
  background-color: #F2F2F2;
  height: 1px;
  min-height: 1px;
  max-height: 1px;
  opacity: 1;
  transform: rotate(0deg);
}

:global(.clb-tab) {
  border-bottom: var(--border-width-xs) solid #e1e1e1;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */